import React from 'react';
import { Link } from 'react-router-dom';

const FeatureImg = () => {
    return (
        <>
            <section className='image-feature pt-60 pb-120'>
                <div className='container'>
                    <div className='row justify-content-between align-items-center'>
                        <div className='col-lg-12 col-12 order-lg-1'>
                            <div className='feature-img-content'>
                                <div className='icon-box rounded-custom bg-dark shadow-sm d-inline-block'>
                                </div>
                                <h2>Why Choose Our Storage Gateway?</h2>
                                <p>
                                    Our Storage Gateway provides the perfect balance of local control and cloud scalability, enabling your organization to embrace the cloud while retaining
                                    the performance benefits of on-premises storage. It’s the ideal solution for businesses looking to modernize their infrastructure, improve storage efficiency, and
                                    enhance disaster recovery strategies—all while minimizing complexity and cost.
                                </p>


                            </div>
                        </div>
                        {/* <div className='col-lg-6 col-12 order-lg-0'>
                            <div className='feature-img-holder mt-4 mt-lg-0 mt-xl-0'>
                                <img
                                    src='/assets/img/screen/widget-12.png'
                                    className='img-fluid'
                                    alt='feature-img'
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default FeatureImg;
